import Client from "./_client";

export const getUserCodeDetailById = async (id) => {
  const url = `/userCodeDetail/${id}?include=batch`;

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get user code detail. Please try again."
    );
  }

  return result?.data;
};
